import React from 'react';
import { Heart, Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-column footer-main">
            <div className="footer-logo">
              <Heart size={32} className="logo-icon" />
              <div>
                <div className="footer-logo-text">Dr. Rajesh Kumar</div>
                <div className="footer-logo-subtitle">Senior Consultant Cardiologist</div>
              </div>
            </div>
            <p className="footer-description">
              Providing world-class cardiovascular care with a commitment to excellence, compassion, and patient-centered medicine.
            </p>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#about">About</a></li>
              <li><a href="#specializations">Specializations</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#booking">Book Appointment</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <a href="tel:+919876543210">+91 98765 43210</a>
              </li>
              <li>
                <Mail size={16} />
                <a href="mailto:appointments@drkumar.clinic">appointments@drkumar.clinic</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>Mumbai, India</span>
              </li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Consultation Hours</h3>
            <ul className="footer-hours">
              <li>
                <span>Mon - Fri</span>
                <span>2:00 PM - 6:00 PM</span>
              </li>
              <li>
                <span>Saturday</span>
                <span>10:00 AM - 2:00 PM</span>
              </li>
              <li>
                <span>Sunday</span>
                <span>By Appointment</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-disclaimer">
            <p><strong>Medical Disclaimer:</strong> The information provided on this website is for educational purposes only and should not be considered as medical advice. Always consult with a qualified healthcare professional for diagnosis and treatment.</p>
          </div>
          <div className="footer-copyright">
            <p>© {currentYear} Dr. Rajesh Kumar. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
